import { render, staticRenderFns } from "./filmPrice.vue?vue&type=template&id=e04f3fd4&"
import script from "./filmPrice.vue?vue&type=script&lang=js&"
export * from "./filmPrice.vue?vue&type=script&lang=js&"
import style0 from "./filmPrice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports